import { BorderRadius, Button, Color, Divider, Dropdown, Icon, Input } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

type PlacementType = 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end'

interface SearchWithFiltersProps {
  searchQuery?: string
  onSearchChange: (value: string | undefined) => void
  searchPlaceholder: string
  filtersPanel?: ReactElement
  filtersDropdownSize?: 'xl' | 'xxl'
  filtersDropdownPlacement?: PlacementType
  onPanelOpen?: () => void
  onPanelClose?: () => void
}

export const SearchWithFilters = ({
  searchQuery,
  onSearchChange,
  searchPlaceholder,
  filtersPanel,
  filtersDropdownSize = 'xl',
  filtersDropdownPlacement = 'bottom-end',
  onPanelOpen,
  onPanelClose,
}: SearchWithFiltersProps): ReactElement => {
  const { t } = useTranslation()

  const handleChangeDebounced = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onSearchChange(event.target.value || undefined)
    },
    [onSearchChange],
  )

  const handleClear = useCallback(() => {
    onSearchChange(undefined)
  }, [onSearchChange])

  return (
    <Styled.Wrapper>
      <Input
        allowClear
        bordered={false}
        isRounded
        size="sm"
        prefix={<Icon icon="search" />}
        value={searchQuery ?? ''}
        onChangeDebounced={handleChangeDebounced}
        onClear={handleClear}
        placeholder={searchPlaceholder}
      />
      {filtersPanel && (
        <>
          <Divider direction="vertical" dividerColor={Color.Grey200} />
          <Styled.FiltersButtonWrapper>
            <Dropdown
              onOpen={onPanelOpen}
              onClose={onPanelClose}
              placement={filtersDropdownPlacement}
              size={filtersDropdownSize}
              trigger={
                <Button
                  variant="text"
                  size="sm"
                  skipLeftRounding
                  fullWidth
                  borderRadius={`0 ${BorderRadius.RFull} ${BorderRadius.RFull} 0`}
                  icon="listFilter"
                >
                  {t('bank_transactions.toolbar.filters')}
                </Button>
              }
            >
              {filtersPanel}
            </Dropdown>
          </Styled.FiltersButtonWrapper>
        </>
      )}
    </Styled.Wrapper>
  )
}
